import React from 'react';
import { getWhatsAppUrl, getEmailUrl } from '../utils/contact';

const Services = () => {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container split-section">
          <div>
            <p className="eyebrow">Services</p>
            <h1>Implementation, customization, and training for modern pharma teams.</h1>
            <p className="section-intro left">
              We help organizations adopt the right tools, improve compliance workflows, and
              build internal capacity with structured training.
            </p>
            <div className="cta-buttons">
              <a href={getWhatsAppUrl('I am interested in ProgrammoCeuticals services')} className="btn btn-primary">Start a Project</a>
              <a href={getEmailUrl('Service Inquiry')} className="btn btn-secondary">Email Us</a>
            </div>
          </div>
          <div className="section-visual">
            <img src="/images/health-lagos.jpg" alt="Nigerian healthcare professional using technology" />
          </div>
        </div>
      </section>

      <section className="services-grid-section section-surface">
        <div className="container">
          <h2>Core Service Areas</h2>
          <p className="section-intro">
            From consulting to training, our services are designed to deliver measurable outcomes.
          </p>
          <div className="services-grid">
            <div className="service-card">
              <h2>Consulting & Implementation</h2>
              <ul>
                <li>Regulatory process consulting</li>
                <li>Documentation workflow optimization</li>
                <li>Digital transformation for faculty and industry</li>
              </ul>
            </div>
            
            <div className="service-card">
              <h2>Custom Software Development</h2>
              <ul>
                <li>Portals and dashboards</li>
                <li>Workflow automation systems</li>
                <li>API integrations and data systems</li>
              </ul>
            </div>
            
            <div className="service-card">
              <h2>Training & Upskilling</h2>
              <ul>
                <li>Technical cohorts (Frontend, Python, Data Science)</li>
                <li>Corporate training for industry teams</li>
                <li>Faculty development programs</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="services-process">
        <div className="container">
          <h2>How Engagement Works</h2>
          <div className="process-steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Discovery</h3>
              <p>We map your workflows, goals, and compliance requirements.</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>Proposal</h3>
              <p>We deliver a clear scope, timeline, and implementation plan.</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Build</h3>
              <p>We configure or build the solution and provide documentation.</p>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <h3>Support</h3>
              <p>We offer training, ongoing support, and improvements.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-cta section-surface">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p className="section-intro">
            Tell us about your team and we will recommend the right service package.
          </p>
          <div className="cta-buttons">
            <a href={getWhatsAppUrl('I am interested in ProgrammoCeuticals services')} className="btn btn-primary">WhatsApp</a>
            <a href="tel:+2349033782254" className="btn btn-secondary">Call</a>
            <a href={getEmailUrl('Service Inquiry')} className="btn btn-tertiary">Email</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
